export const GET_LIST_COUNTRIES = 'GET_LIST_COUNTRIES';
export const GET_LIST_STATE = 'GET_LIST_STATE';
export const GET_LIST_GENDER = 'GET_LIST_GENDER';
export const GET_LIST_CATEGORIES = 'GET_LIST_CATEGORIES';
export const GET_LIST_PAYMENTS = 'GET_LIST_PAYMENTS';
